import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectData, BimUpdateContractObjectMutation } from 'gql/graphql';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback } from 'react';

import { bimUpdateContractObjectGql } from '../BimContractStructureRequests';

interface IUseBimUpdateContractObject {
    onSuccess: (item: BimContractObjectData) => void;
    onClose: () => void;
}

const requestId = 'bimUpdateContractObject';

export const useBimUpdateContractObject = (props: IUseBimUpdateContractObject) => {
    const { onClose, onSuccess } = props;

    const [resetBimCreateContractObject] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(
        (depsVars: TActionCommonInterface<BimUpdateContractObjectMutation>) => {
            if (depsVars?.payload?.bimUpdateContractObject?.data) {
                onSuccess(depsVars?.payload?.bimUpdateContractObject?.data);
            }

            onClose();
            resetBimCreateContractObject(undefined);
        },
        [onClose, onSuccess, resetBimCreateContractObject],
    );

    const [, , , bimUpdateContractObjectRequest] = useRequest({
        requestId,
        query: bimUpdateContractObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    return bimUpdateContractObjectRequest;
};
